import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from "@coreui/react"
import { Flex, Select, Typography } from "antd"
import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getTrainers } from "src/store/Slices/DropDownSlice"
import { assignLeadedTrainingTrainer } from "src/store/Slices/ClientsSlice"

const AssignLeadedTrainerModal = ({
  visible,
  setVisible,
  trainingInfo,
  onSaved,
}) => {
  const dispatch = useDispatch()
  const trainersList = useSelector((state) => state.DropDownSlice.trainersList)
  const [trainerId, setTrainerId] = useState()
  const [saving, setSaving] = useState(false)

  const userLeadedTrainingId =
    trainingInfo?.userLeadedTrainingId ?? trainingInfo?.id

  useEffect(() => {
    if (visible) {
      dispatch(getTrainers({ clubId: trainingInfo?.clubId }))
      setTrainerId(trainingInfo?.trainerId)
    }
  }, [visible, trainingInfo, dispatch])

  const close = () => setVisible(false)

  const save = (nextTrainerId) => {
    if (!userLeadedTrainingId) return
    setSaving(true)
    dispatch(
      assignLeadedTrainingTrainer({
        userLeadedTrainingId,
        trainerId: nextTrainerId ?? null,
      }),
    ).then((result) => {
      setSaving(false)
      if (result.payload) {
        onSaved()
        close()
      }
    })
  }

  return (
    <CModal alignment='center' visible={visible} onClose={close}>
      <CModalHeader>
        <CModalTitle>Назначить / снять тренера</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <Flex vertical gap={16} style={{ marginTop: "12px" }}>
          <div>
            <Typography.Title level={5}>Тренер</Typography.Title>
            <Select
              style={{ width: "100%" }}
              options={trainersList?.data?.value}
              onChange={setTrainerId}
              value={trainerId}
              placeholder='Выбрать'
              allowClear
            />
          </div>
        </Flex>
      </CModalBody>
      <CModalFooter>
        <CButton color='secondary' className='text-light' onClick={close}>
          Закрыть
        </CButton>
        <CButton
          color='danger'
          className='text-light'
          disabled={saving || !userLeadedTrainingId}
          onClick={() => save(0)}
        >
          Снять
        </CButton>
        <CButton
          color='primary'
          className='text-light'
          disabled={saving || !trainerId || !userLeadedTrainingId}
          onClick={() => save(trainerId)}
        >
          Назначить
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default AssignLeadedTrainerModal
